(function($, window, undefined) {

  var defaults = {
    selectorPrefix: 'wbsk-cart'
  };

  function wbskCart(element, settings) {
    this.element = $(element)
    this.settings = $.extend({}, defaults, settings);
    this.removeCtrl = `.${this.settings.selectorPrefix}__remove-from-cart`;
    this.qtySelector = `.${this.settings.selectorPrefix}__item-qty-selctor`;
    this.qtyCtrl = `.${this.settings.selectorPrefix}__item-qty`;
    this.wrapper = `.${this.settings.selectorPrefix}__wrapper`;
    this.cartTemplate = $(`.${this.settings.selectorPrefix}__cart-template`);
    this.count = $(`.${this.settings.selectorPrefix}__cart-count`);
    this.count_items = $(`.${this.settings.selectorPrefix}__cart-count-items`);
    this.actions = `.${this.settings.selectorPrefix}__actions`;
    this.empty = `.${this.settings.selectorPrefix}__empty`;
   
    this.bind();
    this.update('init');
  };
  
  wbskCart.prototype = {
    
    arraySum:function(array){
       return array.reduce((a, b) => a + b, 0)
    },
    bind: function() {
      var _this = this;
      //remove item
      $(document).on('click', this.removeCtrl, function(e) {
        e.preventDefault()
        _this.removeItem($(this))
      })
      //qty change event
      $(document).on('change', this.qtyCtrl, function(e) {
        e.preventDefault()
        _this.updateQty($(this))
      }.debounce(100))
      
    },
    
    postToCart:function(data,url){
      var _this = this;
      url = url || '/cart/add.js'
      return new Promise(function(resolve,reject){
        $.ajax({
          type: 'POST',
          url:url,
          data:data, 
          dataType: 'json',
          success: function(cart) {
            resolve(cart)
          },
          error:function(err) {
            reject(err)
          }
        });  
      })
    },

    addToCart:function(form,data){
      var _this = this;
      return new Promise(function(resolve,reject){
        data = data ? data : $(form).serialize() 
        _this.postToCart(data).then(function(cart){
          _this.update('add').then(function(){
            if(_this.settings.onAdded && typeof _this.settings.onAdded == 'function'){
               _this.settings.onAdded(cart)
            }
            resolve(cart)
          })
        }).catch(function(err){
          reject(err)
        })
      })
    },
    
    addArrayToCart:function(data){
      var _this = this;
      if(_this.settings.loadingClass && _this.settings.loadingClassElement){
        _this.settings.loadingClassElement.addClass(_this.settings.loadingClass)
      }
      return new Promise(function(resolve,reject){
        const item = data.shift()
        _this.postToCart(item).then( cart => {
          if(data.length){
            _this.addArrayToCart(data)
          }else{
            _this.update('add').then(function(){
              if(_this.settings.onAdded && typeof _this.settings.onAdded == 'function'){
                 _this.settings.onAdded(cart)
              }
              resolve(cart)
            })
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    
    update:function(type){
      var _this = this,
          url = _this.settings.cartFetchUrl;
      return new Promise(function(resolve,reject){
        if(_this.settings.loadingClass && _this.settings.loadingClassElement){
          _this.settings.loadingClassElement.addClass(_this.settings.loadingClass)
        }
        _this.fetchHandler(url).then(function(result){
          return result.text();
        }).then(function(html){
          _this.cartTemplate.html(html)
          if(_this.settings.loadingClass && _this.settings.loadingClassElement){
            _this.settings.loadingClassElement.removeClass(_this.settings.loadingClass)
          }
          _this.getCartJSON().then(function(cart){
            // save the cart json
            _this.cart_data = cart
            // get a list of all variant qtys in the cart
            let cart_variant_qtys = cart.items.map( item => {
              return {
                variant_id:item.variant_id,
                quantity:item.quantity
              }
            })
            
            _this.cart_variant_qtys = {}
            cart_variant_qtys.forEach( item => {
              _this.cart_variant_qtys[item.variant_id] = _this.cart_variant_qtys[item.variant_id] || 0
              _this.cart_variant_qtys[item.variant_id] = _this.cart_variant_qtys[item.variant_id] + item.quantity
            })
            const count = cart.item_count
            //update the cart counter
	       _this.count.text(count)
           _this.count_items.text(`${count} ${count == 1 ? 'Item' : 'Items'}`)
    
            //fire the update event
            var event = new CustomEvent('update_cart' , {bubbles: true});
            event.updateType = type
            event.cart = cart
            _this.element[0].dispatchEvent(event);
            
            PubSub.publish('onWbskCartUpdate',cart)
            resolve()

            if(typeof BOLD === 'object' && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function') {
              BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded");
            }
          })
        })
      })
    },
    
    updateQty:function($item){
      var _this = this,
          url = $item.attr('data-update') + $item.val();
      if(_this.settings.loadingClass && _this.settings.loadingClassElement){
        _this.settings.loadingClassElement.addClass(_this.settings.loadingClass)
      }
      _this.fetchHandler(url).then(function(res){
        _this.update()
      })
    },
    
    removeItem:function($item){
      var _this = this;
      if(_this.settings.loadingClass && _this.settings.loadingClassElement){
        _this.settings.loadingClassElement.removeClass(_this.settings.loadingClass)
      }
      _this.fetchHandler($item.attr('href')).then(function(res){
        _this.update('remove')
      })
      
    },
    
    fetchHandler:function(url){
      return new Promise(function(resolve,reject){
        fetch(url).then(function(result){
          resolve(result)
        }).catch(function(error){
          reject(error)
        })
      })
    },
    
    getCartJSON:function(){
      var _this = this
      return new Promise(function(resolve,reject){
        fetch('/cart.js').then(function(result){
          return result.json()
        }).then(function(data){
          resolve(data)
        });
      })
    },
    
    removeItemsByProperty:function(key,value){
      var _this = this
      return new Promise(function(resolve,reject){
        if(_this.settings.loadingClass && _this.settings.loadingClassElement){
          _this.settings.loadingClassElement.addClass(_this.settings.loadingClass)
        }
        const items = _this.cart_data.items.filter( item => item.properties && item.properties[key] && item.properties[key] == value)
        const data = { updates: {} };
 
        for (const item of items) {
          data.updates[item.key] = 0;
        }

        _this.postToCart(data,'/cart/update.js').then( cart => {
          _this.update()
        })
       
       
      })
    },
    
    removeItemsByUidAndParseLogoSetUpItems:function(uid){
      var _this = this
      return new Promise(function(resolve,reject){
        
        if(_this.settings.loadingClass && _this.settings.loadingClassElement){
          _this.settings.loadingClassElement.addClass(_this.settings.loadingClass)
        }
        
        const cart_items = _this.cart_data.items
        const itemsToRemoveRequestData = { updates: {} };
        let cartChangeRequestsData = false
        
        // get the items we want to remove and put them into the data object to pass to cart/updates.js
   
        const itemsToRemoveByUID = cart_items.filter( item => item.properties && item.properties['_uid'] && item.properties['_uid'] == uid && item.properties['_slapp_product_type'] != 'logoSetup' )
        for (const item of itemsToRemoveByUID) {
          itemsToRemoveRequestData.updates[item.key] = 0;
        }
        
        // get the logo set up line item we need to update
        let setUpLineItem = cart_items.filter( item => item.properties && item.properties['_uid'] && item.properties['_uid'] == uid && item.properties['_slapp_product_type'] == 'logoSetup' )
        setUpLineItem = setUpLineItem.length ? setUpLineItem[0] : false
        
        // get the recipe data and check if there is any new logos
        const itemsToRemoveRecipeData = JSON.parse(itemsToRemoveByUID[0].properties._SlappRecipe)
        const logoSetupCount = _this.arraySum(itemsToRemoveRecipeData.views.map(item => item.new_logo_count))
        
        // get the cart items with the same recipe id
        const siblingCartItems = cart_items.filter( item => item.properties._RecipeID && item.properties._RecipeID == itemsToRemoveRecipeData.recipe_id && item.properties._uid != uid) 

        // if there is a logo setup charge for this item + other items in the cart with the same recipe, re-assign recipe line item to sibling product
        if(logoSetupCount && siblingCartItems.length && setUpLineItem){
         
          // get the first sibling item
          const allCartItemUids = [... new Set(siblingCartItems.map( item => item.properties._uid ))]     
          const siblingRecipeItemsGroupedByUid = allCartItemUids.map(item_uid => {
            return siblingCartItems.filter(item => item.properties._uid == item_uid)
            
          })
          const firstSiblingLineItem = siblingRecipeItemsGroupedByUid[0][0]
          
          // get the slapp recipes
          const setUpLineItemSlappRecipe = JSON.parse(setUpLineItem.properties._SlappRecipe)
          const firstSiblingLineItemSlappRecipe = JSON.parse(setUpLineItem.properties._SlappRecipe)
          
          // assign the product images  + product id to the setUpLineItem recipe
          setUpLineItemSlappRecipe.product_id = firstSiblingLineItem.product_id
          setUpLineItemSlappRecipe.views = setUpLineItemSlappRecipe.views.map( (view,index) => {
            view.image = firstSiblingLineItemSlappRecipe.views[index].image
            return view
          })
          setUpLineItem.properties._SlappRecipe = JSON.stringify(setUpLineItemSlappRecipe)
          //update the other properties and create /change request
          setUpLineItem.properties._uid = firstSiblingLineItem.properties._uid
          setUpLineItem.properties._ImageURL = firstSiblingLineItem.properties._ImageURL
          cartChangeRequestsData = {
            id:setUpLineItem.key,
            properties:setUpLineItem.properties
          }
          
          /*
          // update the new_logo_count item in each view of the firstSiblingLineItemSlappRecipe
          firstSiblingLineItemSlappRecipe.views = firstSiblingLineItemSlappRecipe.views.map( (view,index) => {
            view.new_logo_count = setUpLineItemSlappRecipe.views[index].new_logo_count
            return view
          })
          // update the _slap recipe for all the line items that we are assigning the set up item to
          const cartChangeRequests = siblingRecipeItemsGroupedByUid[0].map( line_item => {
            const newLineItem = {
              id:line_item.id,
              properties:line_item.properties
            }
            newLineItem.properties._SlappRecipe.views = newLineItem.properties._SlappRecipe
            return newLineItem
          })
          */
        }else{
          if(setUpLineItem){
            // if there is no matching items, we need to add the setup item to the itemsToRemoveRequestData array 
            itemsToRemoveRequestData.updates[setUpLineItem.key] = 0
          }
        }
             
        _this.postToCart(itemsToRemoveRequestData,'/cart/update.js').then( cart => {
          if(cartChangeRequestsData){
            _this.postToCart(cartChangeRequestsData,'/cart/change.js').then( cart => {
            }).then( cart => {
              _this.update()
            }).catch(err => {
              console.log(err)
            })
          }else{
            _this.update()
          }
        })       
      })
    },
    
    removeItemsByKey:function(key){
      var _this = this
      return new Promise(function(resolve,reject){
        if(_this.settings.loadingClass && _this.settings.loadingClassElement){
          _this.settings.loadingClassElement.addClass(_this.settings.loadingClass)
        }
        const items = _this.cart_data.items.filter( item => item.key == key)
        const data = { updates: {} };
 
        for (const item of items) {
          data.updates[item.key] = 0;
        }

        _this.postToCart(data,'/cart/update.js').then( cart => {
          _this.update()
        })
       
       
      })
    }
    
  };

  $.fn.wbskCart = function(settings) {
    return this.each(function () {
      $.data(this, 'wbskCart', new wbskCart(this, settings))
    })
  }

}(jQuery, window));

